import seek, { seekTypes } from '@adc/seek'
import type { CollectionResult } from '@adc/sdk/types'

type FetchResult = {
  data: CollectionResult
  errors: Record<string, unknown>[]
}

type ISearchListings = {
  seekType?: seekTypes
  operationName?: string
  dsl: Parameters<seek['dsl']>['0'] // grab the dsl (param) type that seek.dsl() will expect
  fields: string[]
  fieldsConfig?: Parameters<seek['fields']>[1] // grab the fieldsConfig (param) type that seek.fields() will expect
  sortField?: string
  sortDirection?: string
  paginationState?: {
    pageSize: number
    offset: number
  }
}

export const searchListings = ({
  seekType = seekTypes.LISTINGS, // default to god index
  operationName = 'searchListings',
  dsl = {},
  fields = [],
  fieldsConfig,
  sortField = 'update_date',
  sortDirection = 'desc',
  paginationState = {
    pageSize: 25,
    offset: 0,
  },
}: ISearchListings): Promise<FetchResult> => {
  const seeker = seek
    .for(seekType)
    .operationName(operationName)
    .dsl(dsl)
    .fields(fields, fieldsConfig)
    .sortByField(sortField, sortDirection)
    .size(paginationState.pageSize)
    .offset(paginationState.offset)

  return seeker.execute().then(
    ({
      data,
      errors,
    }: {
      data: {
        seek: CollectionResult
      }
      errors: Record<string, unknown>[]
    }) => {
      const result = {
        data: data.seek,
        errors,
      }
      return result
    }
  )
}
